import {Order, OrderItem} from 'aigens-ng-core';
import {MobileBasePage} from '../../../core/base/mobile-base-page';
import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {OrderDetailPage} from '../order-detail/order-detail';
import {IonSlide, Events} from '@ionic/angular';
import {TransactionsConfirm} from '../../../dialogs/transactions-confirm/transactions-confirm.component';
import {getDateStringLabel, timeStringLabel} from '../../../shared/utilities/checkFormatTool';

/*
  Generated class for the ByodSummary page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
declare var genkiJSInterface: any;

@Component({
    selector: 'page-summary-list',
    templateUrl: 'summary-list.html',
    styleUrls: ['summary-list.scss']
})

export class SummaryListPage extends MobileBasePage implements OnInit {
    @ViewChild('currentOrderSlides') slides: IonSlide;

    orders: Order[];
    currentOrders: Order[] = [];
    completedOrders: Order[] = [];
    listExpand: {} = {};
    loadingTime: string;
    session: string;
    partial = true;

    limitFrom = 0;
    limitTo = 10;
    limitToExtra = 11;
    savedOrders: {} = {};

    canGoNextPage = false;

    constructor(injector: Injector,public events: Events) {

        super(injector);
        this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + this.currentTimeString();
        this.session = this.getNavParams('sessionId');
        if (!this.session) {
            this.session = this.orderService.session;
        }
    }

    ngOnInit() {

        super.ngOnInit();

        if (!this.orders) {
            this.getOrders();
        }
    }

    handlingCacheOrders(limitFrom: number) {
        this.orders = this.savedOrders[this.limitFrom];
        this.resetOrderGrouping();
        this.groupingOrder(this.savedOrders[this.limitFrom]);
        this.canGoNextPage = this.savedOrders[this.limitFrom]['haveNextPage'];
    }

    // check if orders.length >= 10
    nextPageClicked() {
        this.limitFrom += 10;
        this.limitTo += 10;
        this.limitToExtra += 10;

        if (this.savedOrders[this.limitFrom]) {
            // orders are previously saved
            this.handlingCacheOrders(this.limitFrom);
        } else {

            this.getOrders();
        }
    }

    // check if limitto === 0
    previousPageClicked() {
        this.limitFrom -= 10;
        this.limitTo -= 10;
        this.limitToExtra -= 10;


        this.handlingCacheOrders(this.limitFrom);

    }

    getOrders(refresher?): void {

        // limitTo:number = 10,limitFrom:number = 0
        this.loading(true);
        const today: number = new Date().getTime();
        let since: number = new Date().getTime();
        since = today - 31556952000;
        console.log('since time', since);
        // var limitFrom: number = 0;
        // var limitTo: number = 10;

        this.orderService.getOrders(this.session, this.partial, this.limitToExtra, this.limitFrom, since).subscribe(
            orders => {
                if (refresher) {
                    refresher.complete();
                }
                this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + this.currentTimeString();
                this.orders = orders;
                console.log('getorder', orders);

                if (this.orders && this.orders.length > 0) {
                    this.orders.forEach(order => {

                        if (order.orderitems) {
                            order.orderitems.forEach(oi => {
                                // oi.makeFlatItems();
                                OrderItem.flattenItems(oi);
                            });
                        }
                        if (order.pickup) {
                            order['pickupTimeLabel'] = timeStringLabel(order.pickup);

                        }
                    });
                }

                this.resetOrderGrouping();
                this.groupingOrder(orders.slice(0, 10));

                // savedOrders only if savedOrders is null
                if (!this.savedOrders[this.limitFrom]) {

                    this.savedOrders[this.limitFrom] = orders.slice(0, 10);


                    if (orders.length > 10) {
                        this.savedOrders[this.limitFrom]['haveNextPage'] = true;
                        this.canGoNextPage = this.savedOrders[this.limitFrom]['haveNextPage'];
                    } else {
                        this.savedOrders[this.limitFrom]['haveNextPage'] = false;
                        this.canGoNextPage = this.savedOrders[this.limitFrom]['haveNextPage'];
                    }

                }
                this.loading(false);

            },
            err => {
                this.loading(false);
                if (refresher) {
                    refresher.complete();
                } else {
                    this.showError(err);
                }
                this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + this.currentTimeString();
                console.log(err);

            },
            () => {
                this.loading(false);
            }
        );

    }

    async pickupHandler(order: Order) {
        const modal = await this.modalController.create({
            component: TransactionsConfirm, componentProps: {
                order: order, handler: () => {
                    // call api here
                    this.orderService.orderChangeStatus('completed', order.id).subscribe((tmpOrder) => {
                            modal.dismiss();
                            this.getOrders();
                            tmpOrder.orderitems = order.orderitems;
                            tmpOrder.store = order.store;
                            this.orderClicked(tmpOrder);

                        },
                        err => {
                            this.showError(err);
                            modal.dismiss();

                            console.log(err);

                        });
                }
            }
        });
        modal.present();

    }

    showAllOrder() {
        this.partial = false;
        this.loading(true);
        this.getOrders();
    }

    orderClicked(order: Order) { 
        console.log("TCL: SummaryListPage -> orderClicked -> order", order)
        this.pushByName('MultiOrderDetailPage', {orderDetail : order}).then(()=> {
            console.log("MultiOrderDetailPage done");
            this.events.publish('pushToOrderDetail',{orderDetail: order})
        });

    }

    doRefresh(refresher?) {
        this.getOrders(refresher);
    }

    onRefreshUI() {
        console.log('refresh ui');
        this.doRefresh();
    }

    currentTimeString(): string {
        return timeStringLabel(null, true);
    }

    resetOrderGrouping() {
        this.currentOrders = [];
        this.completedOrders = [];
    }

    groupingOrder(orders: Order[]) {

        orders.forEach((order) => {

            if (order.status === 'ready') {
                this.currentOrders.push(order);
            } else if (order.status === 'received') {
                this.currentOrders.push(order);
            } else if (order.status === 'paid') {
                this.currentOrders.push(order);
            } else if (order.status === 'completed') {
                this.completedOrders.push(order);
            } else if (order.status === 'pending') {
                this.currentOrders.push(order);
                // tmp
                this.completedOrders.push(order);
            } else if (order.status === 'cancelled') {
                this.completedOrders.push(order);
            } else if (order.status === 'failed') {
                this.completedOrders.push(order);
            }
        });

    }

    isSet(oi: OrderItem) {
        return OrderItem.isSet(oi);
    }

    public pageName(): string {
        return '/summary-list';
    }
}
